import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { publicApi } from '../utils/api';
import LoadingOverlay from '../components/LoadingOverlay';
import { Input } from 'antd';

const AUTH_CONFIG = {
  tokenStorageKey: 'admin-auth-token',
  tokenExpiryKey: 'admin-auth-expiry',
};

function isAuthenticated(): boolean {
  try {
    const token = localStorage.getItem(AUTH_CONFIG.tokenStorageKey);
    const expiry = localStorage.getItem(AUTH_CONFIG.tokenExpiryKey);
    if (!token || !expiry) return false;
    if (Date.now() > parseInt(expiry, 10)) {
      localStorage.removeItem(AUTH_CONFIG.tokenStorageKey);
      localStorage.removeItem(AUTH_CONFIG.tokenExpiryKey);
      return false;
    }
    return true;
  } catch {
    return false;
  }
}

async function authenticate(username: string, password: string): Promise<{ ok: boolean; message?: string }> {
  try {
    const res = await publicApi.post('/api/admin/auth/login', { username, password });
    const token: string = res.data.token;
    const expiresInMs: number = res.data.expiresInMs;
    const expiry = `${Date.now() + (Number.isFinite(expiresInMs) ? expiresInMs : 0)}`;
    localStorage.setItem(AUTH_CONFIG.tokenStorageKey, token);
    localStorage.setItem(AUTH_CONFIG.tokenExpiryKey, expiry);
    return { ok: true };
  } catch (e: any) {
    const msg = e?.response?.data?.error || 'ログインに失敗しました。';
    return { ok: false, message: msg };
  }
}

const AdminLoginPage: React.FC = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    document.title = 'Admin Login - Takagi Portal';
    if (isAuthenticated()) {
      navigate('/admin', { replace: true });
    }
  }, [navigate]);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!username || !password) {
      setError('ユーザー名とパスワードを入力してください。');
      return;
    }
    const result = await authenticate(username, password);
    if (result.ok) {
      setError(null);
      navigate('/admin', { replace: true });
    } else {
      setError(result.message || 'ユーザー名またはパスワードが無効です。');
    }
  };

  return (
    <div style={{
      fontFamily: 'Noto Sans JP, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
      display: 'flex', justifyContent: 'center', alignItems: 'center',
      flexDirection: 'column',
      backgroundColor: '#fff', margin: 0, padding: '1rem'
    }}>
      <LoadingOverlay />
      <div><img src="/logo/logo.svg" alt="Takagi Logo" style={{ height: 44, marginBottom: '1.5rem' }} /></div>
      <div style={{ backgroundColor: '#F4F6F9', padding: '24px', borderRadius: 8, border: '1px solid #BCC2FF', width: 450, maxWidth: '90%', textAlign: 'center' }}>
        <h2 style={{ marginTop: 0, color: '#333333', marginBottom: '1.5rem', fontWeight: 700, fontSize: '20px', lineHeight: '28px' }}>ログイン</h2>
        <form onSubmit={onSubmit}>
          <div style={{ marginBottom: '1.5rem', textAlign: 'left' }}>
            <label htmlFor="username" style={{ display: 'block', marginBottom: '6px', fontWeight: 500, fontSize: '14px', lineHeight: '22px' }}>ユーザー名</label>
            <input id="username" type="text" value={username} onChange={(e) => setUsername(e.target.value)} autoComplete="off"
                   style={{ width: '100%', padding: '.8rem', border: '1px solid #EBEEF2', borderRadius: 6, boxSizing: 'border-box', boxShadow: '0px 1px 4px 0px #4CAFF133 inset', height: '46px' }} />
          </div>
          <div style={{ marginBottom: '1.5rem', textAlign: 'left' }}>
            <label htmlFor="password" style={{ display: 'block', marginBottom: '6px', fontWeight: 500, fontSize: '14px', lineHeight: '22px' }}>パスワード</label>
            <Input.Password
                maxLength={255}
                className="base-input base-input-password"
                onChange={(e)=>setPassword(e.target.value)}
              />
            {error && (
              <div style={{ color: '#e74c3c', fontSize: '.9rem', marginTop: '.5rem', textAlign: 'center' }}>{error}</div>
            )}
          </div>
        
          <button type="submit" className='base-button h-[46px] w-[276px]'>ログイン</button>
          {/* <div style={{ marginTop: '0.75rem', textAlign: 'right' }}>
            <a href="/admin/forgot-password" style={{ color: '#0077C8', textDecoration: 'none' }}>パスワードをお忘れの場合</a>
          </div> */}
        </form>
      </div>
    </div>
  );
};

export default AdminLoginPage;
